import React, { FC, useEffect, useState } from 'react'
import './for-students-page.css'

const ForStudentsPage: FC = () => {
    return (
        <div></div>
    )
}

export default ForStudentsPage